





































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import EventsBookingDetails from "../events/EventsBookingDetails.vue";

import ContactJson from "../../shared/ContactJson";
import EventJson from "../../shared/EventJson";
import EventBookingJson from "../../shared/EventBookingJson";
import { EventWithBookingsJson } from "../../shared/EventJson";
import { EventWithBookingJson } from "../../shared/EventJson";
import { EventBookingStatus, EventBookingStatusNames } from "../../shared/EventBookingStatus";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "EventsAll",
  components: {
    Loading,
    TableView,
    EventsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      EventBookingStatusNames: EventBookingStatusNames,
      showDetails: false,
      detailsMode: "read",
      allEvents: null as EventJson[] | null,
      eventsMoreAvailable: null as boolean | null,
      selectedEventWithBookings: null as EventWithBookingsJson | null,
      selectedEventId: null as number | null,
      selectedEventBookingId: null as number | null,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: EventWithBookingJson | null, mode: string) {
      if (this.selectedEventId != null) {
        if (item != null) {
          this.selectedEventBookingId = item.ID;
        } else {
          this.selectedEventBookingId = null;
        }

        this.detailsMode = mode;
        this.toggleDetails();
      } else {
        alert("Es muss zuerst ein Programm ausgewählt werden.");
      }
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllEvents();
    },

    async loadAllEvents(loadMore: null = null) {
      this.selectedEventId = null;
      this.selectedEventBookingId = null;
      this.selectedEventWithBookings = null;

      var skipAmount = null as number | null;

      //load more
      if (loadMore && this.allEvents != null) {
        this.eventsMoreAvailable = null;
        skipAmount = this.allEvents.length;
      } else {
        this.allEvents = null;
      }

      if (this.restClient != null) {
        try {
          let events = await this.restClient.getEvents(
            null,
            false,
            false,
            false,
            null,
            null,
            null,
            null,
            false,
            skipAmount
          );

          if (loadMore && this.allEvents != null) {
            this.allEvents = this.allEvents.concat(events.events);
          } else {
            this.allEvents = events.events;
          }

          this.eventsMoreAvailable = events.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadSelectedEventWithBookings() {
      if (this.allEvents != null) {
        this.selectedEventWithBookings = null;

        if (this.restClient != null && this.selectedEventId != null) {
          try {
            this.selectedEventWithBookings = await this.restClient.getEventWithBookings(this.selectedEventId);
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    async reloadData() {
      this.loadSelectedEventWithBookings();
    },

    getAllParticipantNames(contacts: ContactJson[]) {
      var participants = "";

      for (let i = 0; i < contacts.length; i++) {
        if (i != 0) {
          participants += ", ";
        }
        participants += contacts[i].firstName;
        participants += " ";
        participants += contacts[i].lastName;
      }

      return participants;
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.reloadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    eventColumns: function (): TableViewColumnDefinitions<EventBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Name (Teilnehmende:r)",
          td: (i) => (i.participants && i.participants.length > 0 ? vue.getAllParticipantNames(i.participants) : "--"),
        },
        {
          th: "Anzahl Teilnehmende",
          td: (i) => (i.participants ? i.participants.length + "" : "--"),
        },
        {
          th: "Name (Erziehungsberechtigte:r)",
          td: (i) => (i.contact && i.contact.lastName != "" ? i.contact.lastName + ", " + i.contact.firstName : "--"),
        },
        {
          th: "Angefragt",
          td: (i) => DateFormatter.formatDateTime(new Date(i.bookingDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.EventBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<EventBookingJson>[];
    },

    selectedEventWithBookingsBookings(): EventBookingJson[] | null {
      if (this.selectedEventWithBookings == null) {
        return null;
      } else {
        return this.selectedEventWithBookings.bookings;
      }
    },

    selectedEventRegistrationsLeftText(): string {
      if (this.selectedEventWithBookings != null) {
        const maxRegistrationCount = this.selectedEventWithBookings.registrationMaximumCount;
        let registrationCount = 0;

        for (let i = 0; i < this.selectedEventWithBookings.bookings.length; i++) {
          if (
            this.selectedEventWithBookings.bookings[i].state != "requested" &&
            this.selectedEventWithBookings.bookings[i].state != "canceled" &&
            this.selectedEventWithBookings.bookings[i].state != "cancellationFeeExported" &&
            this.selectedEventWithBookings.bookings[i].state != "waitingList"
          ) {
            registrationCount++;
          }
        }

        if (maxRegistrationCount === undefined) {
          return "Freie Plätze: [Fehler]";
        }

        let registrationsLeft = maxRegistrationCount - registrationCount;

        if (registrationsLeft < 0) {
          return "Bereits überbucht";
        } else if (registrationsLeft == 1) {
          return "Noch 1 freier Platz";
        } else {
          return "Noch " + registrationsLeft + " freie Plätze";
        }
      }

      return "Lade freie Plätze...";
    },

    selectedEventWaitingListLeftText(): string {
      if (this.selectedEventWithBookings != null) {
        const maxWaitingListCount = this.selectedEventWithBookings.waitingListMaximumCount;
        let waitingListCount = 0;

        for (let i = 0; i < this.selectedEventWithBookings.bookings.length; i++) {
          if (this.selectedEventWithBookings.bookings[i].state == "waitingList") {
            waitingListCount++;
          }
        }

        if (maxWaitingListCount === undefined) {
          return "Warteliste: [Fehler]";
        }

        let waitingListLeft = maxWaitingListCount - waitingListCount;

        if (waitingListLeft < 0) {
          return "Warteliste: Überbucht";
        } else if (waitingListLeft == 1) {
          return "Warteliste: 1 Platz frei";
        } else {
          return "Warteliste: " + waitingListLeft + " Plätze frei";
        }
      }

      return "Lade Warteliste...";
    },
  },
});
